import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { HotelPolicyEditI18n } from "@/components/features/items/edit/hotel-policy/i18n/root";

import { useGetHotelPolicyI18nParams } from "./_hooks/use-get-hotel-policy-i18n-params";

export const HotelPolicyEditPageI18n = () => {
	const { hotelID, activeLangCode, navigator } = useGetHotelPolicyI18nParams();

	return (
		<PageMeta
			title="ホテルポリシー"
			url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.I18N, { hotelID, langCode: activeLangCode })}
		>
			<HotelPolicyEditI18n hotelID={hotelID} activeLangCode={activeLangCode} navigator={navigator} />
		</PageMeta>
	);
};

HotelPolicyEditPageI18n.displayName = "HotelPolicyEditPageI18n";
